module.exports = __webpack_public_path__ + "img/client_logo_1.e4512b44.png";